module.exports = __webpack_public_path__ + "143f4e5a8a20c53d4b513dfcb55c6825.jpg";